// Mensajes de validación de SimpleSchema en español.
// El messageBox por defecto de simpl-schema usa el idioma 'en'; como la app es
// solo español, sobreescribimos las cadenas 'en' con texto en español (evita
// tener que cambiar el idioma activo por instancia). Import de side-effect una
// sola vez desde main.js: cualquier new SimpleSchema(...).newContext() ya
// devuelve estos mensajes vía keyErrorMessage().
import SimpleSchema from 'simpl-schema'

SimpleSchema.setDefaultMessages({
  messages: {
    en: {
      required: '{{label}} es obligatorio',
      minString: '{{label}} debe tener al menos {{min}} caracteres',
      maxString: '{{label}} no puede exceder {{max}} caracteres',
      minNumber: '{{label}} debe ser al menos {{min}}',
      maxNumber: '{{label}} no puede exceder {{max}}',
      minNumberExclusive: '{{label}} debe ser mayor que {{min}}',
      maxNumberExclusive: '{{label}} debe ser menor que {{max}}',
      minDate: '{{label}} debe ser en o después de {{min}}',
      maxDate: '{{label}} no puede ser después de {{max}}',
      badDate: '{{label}} no es una fecha válida',
      minCount: 'Se necesitan al menos {{minCount}} valores',
      maxCount: 'No se permiten más de {{maxCount}} valores',
      noDecimal: '{{label}} debe ser un número entero',
      notAllowed: '{{value}} no es un valor permitido',
      expectedType: '{{label}} debe ser de tipo {{dataType}}',
      regEx: '{{label}} no tiene un formato válido',
      keyNotInSchema: '{{name}} no está permitido',
    },
  },
})
